import RestClient from '../RestClient/RestClient';
import ABTestApiConstants from './ABTestApiConstants';
import { constructUrlWithMboxParams } from '../helpers/MboxHelper';

export const getABTestEngagements = (abTestPayload) => {
    try {
        abTestPayload.abInput.url = ABTestApiConstants.AB_TEST_API_URL;
        const config = {
            url: constructUrlWithMboxParams(abTestPayload.abInput),
            credentials: 'include',
            excludeVersion: true,
            external: true,
            referrerPolicy: 'no-referrer-when-downgrade',
        };
        return RestClient.get(config)
            .then((json) => {
                /* istanbul ignore else */
                if (json.status && json.status !== 200) {
                    return {
                        status: json.status,
                        errorMessage: 'ABTest API Non 200 response',
                    };
                }
                /* istanbul ignore next */
                return json;
            })
            .catch(
                /* istanbul ignore next */
                () => ({
                    errorMessage: 'ABTest API Request Fail',
                })
            );
    } catch (e) {
        return {};
    }
};
